import React from 'react'
import { Select, Grid, Popup } from 'semantic-ui-react'

const { Row, Column } = Grid

const SelectField = ({
  after,
  before,
  children,
  className,
  disabled,
  error,
  label,
  multiple,
  name,
  onChange,
  options,
  required,
  tooltip,
  validated,
  value,
}) => {
  if (!required && !multiple) options.unshift({ value: '', text: '' })
  return (
    <Row className={`field ${className}${required ? ' required' : ''}`}>
      <Column width={4}><span className="field-label">{label}: </span></Column>
      <Column width={8}>
        {before}
        <Select
          disabled={disabled}
          multiple={multiple}
          name={name}
          onChange={(e, event) => onChange(event)}
          options={options}
          required={required || undefined}
          value={value}
        />
        {after}
        {!!tooltip &&
          <Popup
            trigger={<i className="daicon daicon-Help tooltip" />}
            content={tooltip}
            position="right center"
          />

        }
      </Column>
      <Column width={4}>
        {!!error &&
          <Popup
            trigger={<i className="daicon daicon-Attention error" />}
            content={error}
            position="right center"
          />
        }

        {validated && !error &&
          <i className="daicon daicon-Checkmark success" />
        }

        {children}

      </Column>
    </Row>
  )
}

SelectField.defaultProps = {
  className: '',
  validated: false,
  required: false,
  multiple: false,
  error: '',
  tooltip: '',
  children: null,
  before: null,
  after: null,
  disabled: false,
}

SelectField.propTypes = {
  after: React.PropTypes.any,
  before: React.PropTypes.any,
  children: React.PropTypes.any,
  className: React.PropTypes.string,
  disabled: React.PropTypes.bool,
  error: React.PropTypes.string,
  label: React.PropTypes.string.isRequired,
  multiple: React.PropTypes.bool,
  name: React.PropTypes.string.isRequired,
  onChange: React.PropTypes.func.isRequired,
  options: React.PropTypes.array.isRequired,
  required: React.PropTypes.bool,
  tooltip: React.PropTypes.string,
  validated: React.PropTypes.bool,
  value: React.PropTypes.any.isRequired,
}

export default SelectField



// WEBPACK FOOTER //
// ./src/browser/components/fields/Select.js